import React, { useMemo } from 'react';
import { useField, useForm } from 'react-final-form';
import { Button } from 'ksnm-common-ui/lib/Button';
import { SelectField } from 'ksnm-common-ui/lib/Form/SelectField';
import type { ReactElement } from 'react';

import styles from './SelectForm.module.scss';

export const SelectForm = ({ items }: { items: { id: string; name: string | undefined }[] }): ReactElement => {
  const { submit } = useForm();

  const {
    input: { value: version },
  } = useField('version');

  const versionItems = useMemo(() => items ?? [], [items]);

  return (
    <div className={styles.selectForm}>
      <SelectField items={versionItems} label="Выберите версию" size="small" allowClear name="version" />
      <Button onClick={submit} size="small" disabled={!version}>
        Сохранить
      </Button>
    </div>
  );
};
